import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

// Opens the shared inline-edit modal and loads the edit form into the
// turbo-frame inside it. Applied to the per-section pencil link.
export default class extends Controller {
  open(event) {
    event.preventDefault();

    const href = this.element.getAttribute("href");
    const modalEl = document.getElementById("inline-edit-modal");
    if (!modalEl || !href) return;

    const frame = modalEl.querySelector("turbo-frame#inline_edit_frame");
    if (frame) {
      // Setting src triggers Turbo to fetch and render the response into the frame.
      frame.setAttribute("src", href);
    }

    Modal.getOrCreateInstance(modalEl).show();
  }
}
